<div class="requerimento-page">
  <h1 class="title">Requerimento online</h1>

  <!-- Mesmo formato do gráfico de integrações da campanha: total à esquerda e, ao lado, cada tipo
       de benefício com quantidade e percentual sobre uma barra única dividida na mesma proporção. -->
  <section class="indicadores" aria-label="Indicadores do Requerimento Online" data-testid="requerimento-indicadores">
    <div class="indicadores__total">
      <p class="indicadores__rotulo">Total de solicitações</p>
      <p class="indicadores__valor" data-testid="indicador-valor">{{ indicadores().total }}</p>
    </div>

    <div class="indicadores__tipos">
      <ul class="indicadores__legenda">
        @for (tipo of indicadores().tipos; track tipo.label) {
          <li class="indicadores__tipo">
            <p class="indicadores__rotulo">
              <span class="indicadores__cor" [style.background-color]="tipo.color" aria-hidden="true"></span>
              {{ tipo.label }}
            </p>
            <p class="indicadores__quantidade">
              <span class="indicadores__valor" data-testid="indicador-valor">{{ tipo.valorTexto }}</span>
              <span class="indicadores__percentual" data-testid="indicador-percentual">{{ tipo.percentual }}%</span>
            </p>
          </li>
        }
      </ul>

      <!-- Só visual: os números já estão na legenda acima. -->
      <div class="indicadores__barra" aria-hidden="true" data-testid="indicadores-barra">
        @for (tipo of indicadores().tipos; track tipo.label) {
          @if (tipo.value) {
            <span class="indicadores__fatia" [style.flex-grow]="tipo.value" [style.background-color]="tipo.color"></span>
          }
        }
      </div>
    </div>
  </section>

  <section class="status-pie-chart-section" aria-label="Gráficos do Requerimento Online">
    <div>
      <h2 id="grafico-tipo-beneficio-title" class="page-section-title">Requerimentos por tipo de benefício</h2>
      <app-status-pie-chart [segments]="requerimentosPorTipoBeneficio()" />
    </div>
    <div>
      <h2 id="grafico-status-title" class="page-section-title">Requerimentos por status</h2>
      <app-status-pie-chart [segments]="requerimentosPorStatus()" />
    </div>
  </section>

  <app-filter-bar [fields]="filterFields()" (filtersChange)="onFiltersChange($event)" />

  <!-- Lista sem painel em volta: a própria moldura branca da tabela é o card (mesmo layout do Instituto). -->
  <section class="requerimento__lista" aria-labelledby="solicitacoes-section-title" data-testid="requerimento-lista">
    <h2 id="solicitacoes-section-title" class="page-section-title">Solicitações de Requerimento Online</h2>

    @if (solicitacoes().length === 0) {
      <app-empty-state
        [message]="filtroAplicado() ? 'Nenhuma solicitação encontrada para os filtros aplicados' : 'Nenhuma solicitação encontrada'"
      />
    } @else {
      <div class="requerimento__tabela-scroll">
        <table class="requerimento__tabela" aria-label="Solicitações de Requerimento Online" data-testid="requerimento-tabela">
          <thead>
            <tr>
              <th scope="col" [attr.aria-sort]="ariaSort('nome')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'nome', titulo: 'Participante' }" />
              </th>
              <th scope="col" [attr.aria-sort]="ariaSort('matricula')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'matricula', titulo: 'Matrícula' }" />
              </th>
              <th scope="col">Plano</th>
              <th scope="col" [attr.aria-sort]="ariaSort('tipoBeneficio')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'tipoBeneficio', titulo: 'Tipo de benefício' }" />
              </th>
              <th scope="col" [attr.aria-sort]="ariaSort('dataSolicitacao')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'dataSolicitacao', titulo: 'Data Solicitação' }" />
              </th>
              <th scope="col" [attr.aria-sort]="ariaSort('status')">
                <ng-container *ngTemplateOutlet="ordenar; context: { coluna: 'status', titulo: 'Status' }" />
              </th>
              <th scope="col" class="requerimento__coluna-acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            @for (solicitacao of solicitacoesPaginadas(); track solicitacao.idSolicitacao) {
              <tr data-testid="requerimento-linha">
                <td class="requerimento__nome" data-testid="solicitacao-nome">{{ solicitacao.nomeParticipante }}</td>
                <td class="requerimento__secundario" data-testid="solicitacao-matricula">{{ solicitacao.matricula }}</td>
                <td data-testid="solicitacao-plano">{{ solicitacao.plano }}</td>
                <td data-testid="solicitacao-tipo-beneficio">{{ solicitacao.tipoBeneficio }}</td>
                <td class="requerimento__secundario" data-testid="solicitacao-data-solicitacao">
                  {{ solicitacao.dataSolicitacao ? formatDate(solicitacao.dataSolicitacao) : '-' }}
                </td>
                <td>
                  <app-requerimento-status-tag [status]="solicitacao.status" />
                </td>
                <td class="requerimento__coluna-acoes">
                  <app-menu-acoes
                    [rotulo]="'Ações da solicitação de ' + solicitacao.nomeParticipante"
                    [opcoes]="opcoesMenu"
                    (escolher)="onAcao(solicitacao, $event)"
                  />
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Título da coluna + seta; o estado da ordenação para leitores de tela fica no aria-sort do th. -->
      <ng-template #ordenar let-coluna="coluna" let-titulo="titulo">
        <button
          type="button"
          class="ordenar"
          [class.ordenar--ativo]="ariaSort(coluna) !== 'none'"
          [attr.data-testid]="'ordenar-' + coluna"
          (click)="ordenarPor(coluna)"
        >
          {{ titulo }}
          <vivest-icon class="ordenar__icone" [name]="iconeOrdenacao(coluna)" source="feather" aria-hidden="true"></vivest-icon>
        </button>
      </ng-template>

      <app-pagination
        [currentPage]="currentPage()"
        [pageSize]="pageSize()"
        [totalItems]="solicitacoes().length"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      />
    }
  </section>
</div>
